import { $api, fetchClient } from '@/api/typedClient'
import { message } from 'antd'
import { type UserFilters, filterAndPaginateUserResponse } from './transformers'

export const useUsersList = (filters: UserFilters) => {
  const query = $api.useQuery('post', '/meta/user/all', {
    params: { header: { 'X-Tenant-Name': 'Gravitate' } },
  })
  const { error, data } = query

  if (error) {
    throw new Error(`Failed to fetch users: ${JSON.stringify(error)}`)
  }

  const filteredAndPaginatedUsers = filterAndPaginateUserResponse(
    filters,
    data || [],
  )
  return { ...query, data: filteredAndPaginatedUsers }
}

export const useAvailableRoles = () => {
  const query = $api.useQuery('post', '/meta/role/all', {
    params: { header: { 'X-Tenant-Name': 'Gravitate' } },
    staleTime: 300000,
  })
  const { data, error } = query

  if (error) {
    if (error.detail) {
      for (const err of error.detail) {
        message.error(err.msg)
      }
    }
  }

  return { ...query, data }
}

// Export for prefetching
export const fetchCurrentUser = async () => {
  const token = localStorage.getItem('accessToken')
  if (!token) return null

  const { data, error } = await fetchClient.POST('/meta/user/me')
  if (error || !data) return null

  return {
    id: data.email,
    username: data.email?.split('@')[0] || data.email,
    email: data.email,
    full_name: data.name || '',
    role: (data.domains as unknown as { role: string }[])?.[0]?.role || 'user',
    status: data.is_active ? ('active' as const) : ('inactive' as const),
    last_login:
      data.last_login_activity?.activity_date || new Date().toISOString(),
  }
}
